<template>
  <div style="width: 100%" v-if="listSeats">
    <v-row style="width: 100%" no-gutters>
      <HeaderSector />
    </v-row>
    <v-row style="width: 100%" no-gutters>
      <SeatMap :listSeats="listSeats" />
    </v-row>
    <AddTypeInCart
      v-if="selectedSeat"
      :selectedSeat="selectedSeat"
      @unsetSelectedSeat="unsetSelectedSeat"
    />
  </div>
  <v-row class="py-12" v-else no-gutters justify="center">
    <v-progress-circular
      indeterminate
      color="primary"
      size="60"
    ></v-progress-circular>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import HeaderSector from "./Header.vue";
import SeatMap from "./SeatMap.vue";
import AddTypeInCart from "./AddTypeInCart.vue";
export default {
  computed: {
    ...mapGetters(["listSeats", "selectedSeat"]),
  },
  components: { HeaderSector, SeatMap, AddTypeInCart },
  methods: {
    unsetSelectedSeat() {
      let seatElement = document.getElementById(this.selectedSeat.codigo_obj);
      seatElement.classList.remove("selected-seat");
      this.selectedSeat.reserved = false;
      this.$store.commit("SET_SELECTED_SEAT", null);
    },
  },
};
</script>
